



































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Thumb from '@/components/molecules/Thumb/Thumb.vue';

@Component({
  components: {
    FilledButton,
    Thumb
  }
})
export default class CustomerAcquisitionEmailPreview extends Vue {
  @Prop() coinsPerCustomer!: number;
  @Prop({ default: '16px' }) baseFont?: string;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business) return '';

    return business.logo.publicPath.large;
  }
}
